import { render, staticRenderFns } from "./loopSwiper.vue?vue&type=template&id=bc161d48&scoped=true"
import script from "./loopSwiper.vue?vue&type=script&lang=js"
export * from "./loopSwiper.vue?vue&type=script&lang=js"
import style0 from "./loopSwiper.vue?vue&type=style&index=0&id=bc161d48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc161d48",
  null
  
)

export default component.exports